// extracted by mini-css-extract-plugin
module.exports = {"shopifyGrantWrapper":"ShopifyGrant_shopifyGrantWrapper__31t7S","content":"ShopifyGrant_content__ktSVW"};